import { ColumnSizing } from '../tables-context';
import { MRT_ColumnDef } from 'material-react-table';
import { TableCell } from '../../../components/table/TableCell';
import React from 'react';

export interface IAuditLogDetails {
	name: string,
	oldValue: string,
	newValue: string,
}
export enum AuditLogsDetailsTableAccessorKeys {
	name = 'name',
	oldValue = 'oldValue',
	newValue = 'newValue',
}

export const defaultAuditLogsDetailsColumnSizing: ColumnSizing = {
	[AuditLogsDetailsTableAccessorKeys.name]: 50,
	[AuditLogsDetailsTableAccessorKeys.oldValue]: 100,
	[AuditLogsDetailsTableAccessorKeys.newValue]: 100,
};

export const defaultAuditLogsDetailsColumns: MRT_ColumnDef<IAuditLogDetails>[] = [
	{
		accessorKey: AuditLogsDetailsTableAccessorKeys.name,
		header: 'Column name',
		enableSorting: false,
		Header: <span className="text-muted fw-bolder main-font-family">Column name</span>,
		Cell: ({ renderedCellValue, table }: any): JSX.Element => (
			<TableCell
				additionalClass="d-flex align-items-center main-font-family text-black"
				density={table?.options?.state?.density}
				isTextOverflow={true}
			>
				<div className="fc-text-overflow">
					{renderedCellValue ? renderedCellValue : '-'}
				</div>
			</TableCell>
		)
	},
	{
		accessorKey: AuditLogsDetailsTableAccessorKeys.newValue,
		header: 'New value',
		enableSorting: false,
		Header: <span className="text-muted fw-bolder main-font-family">New value</span>,
		Cell: ({ renderedCellValue, table }: any): JSX.Element => (
			<TableCell
				additionalClass="d-flex align-items-center main-font-family text-black"
				density={table?.options?.state?.density}
				isTextOverflow={true}
			>
				<div className="fc-text-overflow">
					{renderedCellValue ? renderedCellValue : '-'}
				</div>
			</TableCell>
		)
	},
	{
		accessorKey: AuditLogsDetailsTableAccessorKeys.oldValue,
		header: 'Old value',
		enableSorting: false,
		Header: <span className="text-muted fw-bolder main-font-family">Old value</span>,
		Cell: ({ renderedCellValue, table }: any): JSX.Element => (
			<TableCell
				additionalClass="d-flex align-items-center main-font-family text-black"
				density={table?.options?.state?.density}
				isTextOverflow={true}
			>
				<div className="fc-text-overflow">
					{renderedCellValue ? renderedCellValue : '-'}
				</div>
			</TableCell>
		)
	},
];
